<template>
  <v-container>
    <v-layout row align-center class="my-3">
      <v-icon color="primary">done_all</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Finalizar Declaración</span>
      <v-spacer/>
      <card-current-time/>
    </v-layout>
    <div v-show="finalizar" v-if="this.estado !== 2">
      <v-layout row justify-center align-center>
        <v-flex md10 sm10 xs10>
          <v-alert align='justify'
            :value="true"
            :color="alert1?'success':'warning'"
            outline
          > <span class="subheading">¿Usted ha terminado de registrar toda la información solicitada en el Formulario Único de la Declaración Jurada de Bienes y Rentas? </span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert1"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row justify-center align-center>
        <v-flex md10 sm10 xs10>
          <v-alert align='justify'
            :value="true"
            :color="alert2?'success':'warning'"
            outline
          > <span class="subheading">¿Usted ha revisado los datos de su Declaración Jurada y está de acuerdo con el contenido? (En la sección anterior puede imprimir un BORRADOR del Formulario de la Declaración Jurada para revisar su contenido) </span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert2"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex md10 sm10 xs10>
          <v-alert align='justify'
            :value="true"
            :color="alert3?'success':'warning'"
            outline
          > <span class="subheading">¿Está consciente, que una vez finalizada la Declaración Jurada de Bienes y Rentas, NO será posible modificar la información? </span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert3"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex md10 sm10 xs10>
          <v-alert align='justify'
            :value="true"
            :color="alert4?'success':'warning'"
            outline
          > <span class="subheading">¿Está consciente de las consecuencias legales de registrar información falsa o incompleta en la Declaración Jurada de Bienes y Rentas? </span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert4"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout align-center justify-end row fill-height>
        <v-btn color="primary" dark @click.stop='dialog = true'><v-icon>done_all</v-icon>&nbsp;Finalizar</v-btn>
      </v-layout>
      
      <v-layout row justify-center>
        <v-dialog v-model="dialog" scrollable persistent max-width="600">
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title><h4>Finalizar la Declaración Jurada de Bienes y Rentas</h4></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text align='justify' v-show="alert1 && alert2 && alert3 && alert4">
              <br/><strong align='justify'>Esta declaración tendrá plena validez legal</strong><br/><br/>
              Una vez finalizado el Formulario de Declaración Jurada de Bienes y Rentas, <strong>NO</strong> se podrá realizar ninguna modificación al formulario. <br/>
              <strong> ¿Confirma usted su intención de finalizar el Formulario de Declaración Jurada de Bienes y Rentas?</strong>
            </v-card-text>
            <v-card-text v-show="!alert1 || !alert2 || !alert3 || !alert4">
              <span color="red">Para finalizar debe responder afirmativamente a <b>todas</b> las condiciones requeridas</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-show="alert1 && alert2 && alert3 && alert4"
                color="primary"
                @click="finalizarModal(), loader = 'loading'"
                :loading="loading"
                :disabled="loading"
              ><v-icon>check</v-icon>&nbsp;
              Confirmar
              <template v-slot:loader>
                 <span>procesando..</span>
                  </template>
              </v-btn>
              <v-btn color="error" v-show="!alert1 || !alert2 || !alert3 || !alert4" :disabled="loading" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Aceptar</v-btn>
              <v-btn color="error" v-show="alert1 && alert2 && alert3 && alert4" :disabled="loading" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>

    <div v-show="!finalizar">
      
      <v-layout align-center justify-center row wrap>
        <h4 align='justify'>
          Usted ha finalizado correctamente el Formulario de Declaración Jurada de Bienes y Rentas
          , pero aún NO SERÁ VALIDO legalmente hasta que siga los siquientes pasos:<br/>
        </h4>
      </v-layout>
      
      <v-layout align-center justify-center row wrap>
        <span align='justify'>1.- Imprimir 2 Ejemplares, <b>EN HOJA TAMAÑO CARTA</b>, del Formulario de Declaración Jurada de Bienes y Rentas. 
          <b>SE RECOMIENDA QUE LA IMPRESIÓN SE REALICE EN UNA HOJA POR PÁGINA. <u>(NOTA: NO DEBE SER ANVERSO Y REVERSO)</u>.</b>
        </span>
      </v-layout>
      <br>
      <v-layout align-center justify-center row wrap>
        <v-btn class="tamanioBoton" :loading='loadingForm' large color="primary" @click="archivoBorrador">
          <v-icon right dark>cloud_download </v-icon>&nbsp;Formulario
        </v-btn>
      </v-layout>
      <br>
      <v-layout row wrap>
        <span align='justify'>2.- Imprimir 2 Ejemplares <b>(HOJA BLANCA TAMAÑO CARTA)</b> del CERTIFICADO de Declaración Jurada de Bienes y Rentas.</span>
      </v-layout>
      <br>
      <v-layout align-center justify-center row wrap>
        <v-btn class="tamanioBoton" :loading='loadingCert' large color="primary" @click="archivoCertificado">
          <v-icon right dark>cloud_download </v-icon>&nbsp;Certificado
        </v-btn>
      </v-layout>
      <br>
      <v-layout row wrap>
        <span align='justify'>3.- Firme los ejemplares del Formulario y Certificado de Declaración Jurada de Bienes y Rentas.</span>
      </v-layout>
      <br>
      <v-layout row wrap>
        <span align='justify'>4.- Para la Presentación de su Declaración Jurada de Bienes y Rentas debe apersonarse a las oficinas de la Contraloría General del Estado, llevando consigo:</span>
        <br>
        <p>
          <ul>
          <li>Los 2 ejemplares firmados del Formulario de Declaración Jurada de Bienes y Rentas.</li>
          <li>Los 2 ejemplares firmados del Certificado de Declaración Jurada de Bienes y Rentas.</li>
          <li>Cédula de Identidad.</li>
          <li>Una fotocopia de la Cédula de Identidad.</li>
          </ul>
        </p>
      </v-layout>
      <br>
      <v-layout align-center justify-center row wrap>
        <v-btn class="tamanioBoton" large color="success" @click="$router.push('/declaracion')">
          <v-icon right dark>done_all</v-icon>&nbsp;Terminar
        </v-btn>
      </v-layout>
      <br>
    </div>

    <v-layout justify-end wrap v-show="botonAnterior">
        <v-btn color="secondary" @click="$router.push('/borrador')">
          <v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior
        </v-btn>
    </v-layout>

  </v-container>
</template>
<script>
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [ Parametricas ],
  created () {
    this.$service.get('djbr_registro/persona_declarante', {}).then(response => {
      if (response) {
        if (response.contrastado_segip === 0) {
          this.$root.$emit('clickedSegip');
        }
      }
    });
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.finalizar = false;
          this.botonAnterior = false;
        }
        if (respuesta.data.cod_estado === 1) {
          this.finalizar = true;
          this.botonAnterior = true;
        }
        if (respuesta.data.cod_estado === 2) {
          this.estado = respuesta.data.cod_estado;
          this.finalizar = false;
          this.botonAnterior = false;
        }
      }
    });
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response.error_existente === 1) {
        this.$message['warning'](response.error_mensaje);
      }
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
    // this.navBarEmmit();
  },
  data: () => ({
    loadingForm: false,
    loadingCert: false,
    finalizar: true,
    dialog: false,
    alert1: false,
    alert2: false,
    alert3: false,
    alert4: false,
    estado: '',
    archivosOk: true,
    interval: null,
    botonAnterior: false,
    loading: false
  }),
  methods: {
    finalizarModal () {
      this.loading = true;
      this.$service.post('djbr_registro/finalizar_declaracion_externo', {}).then(response => {
        if (response && response.err_existente === 0) {
          this.botonAnterior = false;
          this.navBarEmmit();
          this.dialog = false;
          this.loading = false;
          this.finalizar = false;
          this.$message['success'](response.err_existente);
        } else {
          this.dialog = false;
          this.loading = false;
          this.$message['warning'](response.err_mensaje);
        }
      });
    },
    archivoBorrador () {
      this.loadingForm = true;
      this.$service.get(`djbr_registro/borrador_declaracion`, {}).then(response => {
        if (response) {
          this.downloadPDF(response.base64, 'FORMULARIO');
          this.loadingForm = false;
        } else {
          this.loadingForm = false;
        }
      }).catch(e => {
        console.log(e);
        this.loadingForm = false;
      });
    },
    archivoCertificado () {
      this.loadingCert = true;
      this.$service.get(`djbr_registro/generar_certificado`, {}).then(response => {
        if (response) {
          this.downloadPDF(response.base64, 'CERTIFICADO');
          this.loadingCert = false;
        } else {
          this.loadingCert = false;
        }
      }).catch(e => {
        console.log(e);
        this.loadingCert = false;
      });
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(this.b64toBlob(pdf, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}_${this.$storage.get('user').nro_documento}.pdf`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    cancel () {
      this.loading = false;
      this.dialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/declaracion/finalizarNormal.vue